module.exports = __webpack_public_path__ + "static/media/ic-clapping-hands.046a0acf.svg";